export default __webpack_public_path__ + "static/media/bg-stream-a-5.d68b4e11.png";